'use client';

import { useEffect, useState } from 'react';

interface IProps {
  table: string;
  className: string
}

export default function DangerTable(props: IProps) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);
  return (
    <div
    dangerouslySetInnerHTML={{
      __html: show ? props.table : '',
    }}
      className={ props.className }
    >
    </div>
  );
}
